module.exports = __webpack_public_path__ + "img/职工2级@3x.d1513f56.png";